/* unplugin-vue-components disabled */import { render } from "./FloatingElement.vue?vue&type=template&id=f0ae600e"
import script from "./FloatingElement.vue?vue&type=script&lang=js"
export * from "./FloatingElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__